/**
 * Rewrites HTML `<u>…</u>` → markdown-it-ins `++…++` so HTML-style underline
 * maps onto the existing `ins` render rule. Code fences and inline code are
 * preserved as-is so literal samples like `` `<u>x</u>` `` stay intact.
 */
export const UNDERLINE_REGEX = /```[\s\S]*?```|`[^`\n]+`|<u>([\s\S]+?)<\/u>/gi;

export const normalizeUnderline = (text: string): string =>
	text.replace(UNDERLINE_REGEX, (match, content) => {
		if (match.startsWith("`")) {
			return match;
		}
		return `++${content}++`;
	});
